import { render, staticRenderFns } from "./LiveUpComing.vue?vue&type=template&id=93457732&scoped=true&"
import script from "./LiveUpComing.vue?vue&type=script&lang=js&"
export * from "./LiveUpComing.vue?vue&type=script&lang=js&"
import style0 from "./LiveUpComing.vue?vue&type=style&index=0&id=93457732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93457732",
  null
  
)

export default component.exports